import axios from '@axios'

/** 
* Índice
* {@link getEvaluations} - Obtener evaluaciones
* {@link getEvaluation} - Obtener evaluación
* {@link createEvaluation} - Intentar ir quitando os sitios que usan isto
* {@link addEvaluation} - Crear evaluación
* {@link deleteEvaluation} - Eliminar evaluación
* {@link updateEvaluation} - Actualizar evaluación
*/

    /**
     * Obtener todads las evaluaciones
     * @param {*} queryParams 
     * @returns evaluations 
     */
    export const getEvaluations = function (queryParams) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/evaluations', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Obtener evaluación
     * @param {integer} id ID de la evaluación 
     * @returns evaluation
     */

    export const getEvaluation = function ( id ) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/evaluations/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Añadir evaluación
     * @param {*} data Datos del cliente 
     * @returns 
     */

    export const addEvaluation = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/evaluations`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Borrar evaluación
     * @param {integer} id ID de la evaluación a borrar
     * @returns 
     */

    export const deleteEvaluation = function ({ id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/evaluations/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Actualizar evaluación
     * @param {integer} id ID de la evaluación a actualizar 
     * @returns 
     */

    export const updateEvaluation = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/evaluations/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }










